
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56 56"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 17.999a.997.997 0 0 0 .707-.293L27 7.413v35.586a1 1 0 1 0 2 0V7.413l10.293 10.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L28.708 4.293a1.001 1.001 0 0 0-1.416 0L15.293 16.292A.999.999 0 0 0 16 17.999z"}}),_c('path',{attrs:{"d":"M55 37.999a1 1 0 0 0-1 1v11H2v-11a1 1 0 1 0-2 0v13h56v-13a1 1 0 0 0-1-1z"}})])
          )
        }
      }
    